// extracted by mini-css-extract-plugin
export default {"header":"Wait_header__CxZpz","additionalHelp":"Wait_additionalHelp__9OvTz"};